/* tslint:disable */
/* eslint-disable */
/**
 * Webclipping
 * WebclippingのAPI
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 過去記事検索の契約情報。有料契約していないときはnull。
 * @export
 * @interface ArticlePastSearchContract
 */
export interface ArticlePastSearchContract {
    /**
     * 契約開始日（形式：YYYY/mm/dd）
     * @type {string}
     * @memberof ArticlePastSearchContract
     */
    startDate: string;
    /**
     * 契約終了日（形式：YYYY/mm/dd）
     * @type {string}
     * @memberof ArticlePastSearchContract
     */
    endDate: string;
    /**
     * 自動更新した場合の契約開始日（is_auto_renewedがfalseでも返される）
     * @type {string}
     * @memberof ArticlePastSearchContract
     */
    nextPeriodStartDate: string;
    /**
     * 自動更新されるかどうか
     * @type {boolean}
     * @memberof ArticlePastSearchContract
     */
    isAutoRenewed: boolean;
}

export function ArticlePastSearchContractFromJSON(json: any): ArticlePastSearchContract {
    return ArticlePastSearchContractFromJSONTyped(json, false);
}

export function ArticlePastSearchContractFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArticlePastSearchContract {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'startDate': json['start_date'],
        'endDate': json['end_date'],
        'nextPeriodStartDate': json['next_period_start_date'],
        'isAutoRenewed': json['is_auto_renewed'],
    };
}

export function ArticlePastSearchContractToJSON(value?: ArticlePastSearchContract | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'start_date': value.startDate,
        'end_date': value.endDate,
        'next_period_start_date': value.nextPeriodStartDate,
        'is_auto_renewed': value.isAutoRenewed,
    };
}

